
import React from 'react';
import * as api from '../../../../../api';
import DualListBox from 'react-dual-listbox';
import 'react-dual-listbox/lib/react-dual-listbox.css';
import 'font-awesome/css/font-awesome.min.css'
import { Icon,Grid,Message } from 'semantic-ui-react'


class UserClientsTab extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      cutomerList:[],
      selected:[]

    };
    this.fetchData();
    this.onChange = this.onChange.bind(this);
  }
  fetchData() {

    api.getCustomerList()
      .then(data => {
        this.setState({ cutomerList: data });
      }).catch(function (error) {
        // Acquire token interactive failure
        console.log(error);
      });
    api.getUserClient(this.props.id)
      .then(data => {
        this.setState({ selected: data.map((item) => { return item.custKey }) });
      }).catch(function (error) {
        // Acquire token interactive failure
        console.log(error);
      });
  }

  onChange(selected, selection) {
    if (selected.length > 0 && selection.length > 0) {
      for (let item of selection) {
        if (selected.includes(item)) {
          let clientName = this.state.cutomerList.filter((value) => { return value.custKey === item })
          api.addUserClient(this.props.id, item, clientName[0].name)
            .then((data) => {
            })
            .catch((error) => {
              console.log(error)
            })
        }
      }
    }

    if (selected.length >= 0 && selection.length > 0) {
      for (let item of selection) {
        if (!selected.includes(item)) {
          api.removeUserClient(this.props.id,item)
            .then((data) => {
            })
            .catch((error) => {
              console.log(error)
            })
        }
      }
    }

    if (selected.length > 0 && selection.length === 0) {
      for (let item of selected) {
        let clientName = this.state.cutomerList.filter((value) => { return value.custKey === item })
        api.addUserClient(this.props.id, item, clientName[0].name)
          .then((data) => {
          })
          .catch((error) => {
            console.log(error)
          })
      }
    }


    this.setState({ selected });
  }

  render() {
    const options = this.state.cutomerList.map((item) => { return { value: item.custKey, label: item.name } })
    const { selected } = this.state;

    return (
      <div>
           <Grid.Column>
                            <Message warning>
                                <Icon size='large' name='warning sign'/>
                                <b>Please note: </b> This is only required if a customer needs access to more than one client. If the list is empty then it will default to who the account was created under. Please add both clients below to provide multi access e.g. Jones Lang LaSalle and Legal and General
                            </Message>
                        </Grid.Column> <br></br>
      <div className="list-sites-flex">
      <div className="list-sites"> List of Available Clients </div>
      <div className="list-sites mr-sites"> User’s Clients </div>
      </div>
      <DualListBox
          options={options}
          selected={selected} 
          onChange={this.onChange}
          className="edit-user-btn"
          icons={{
            moveLeft: <Icon className="long arrow alternate left" ></Icon>,
            moveRight: <Icon className="long arrow alternate right" ></Icon>,
            // moveAllRight:<span>Add All</span>,
        }}
      />
    </div>
    );
  }

}
export default UserClientsTab